import { Component, inject, Input } from '@angular/core';
import { Table } from '../../../models/class/table.class';
import { CardsService } from '../../../services/cards/cards.service';
import { map, Observable } from 'rxjs';
import { Link } from '../../../models/class/link.class';
import { AsyncPipe } from '@angular/common';
import { TrashComponent } from '../../../../../core/components/svg/trash/trash.component';
import { DatabaseModelService } from '../../../services/database-model/database-model.service';

@Component({
  selector: 'app-table-card',
  standalone: true,
  imports: [AsyncPipe, TrashComponent],
  templateUrl: './table-card.component.html',
  styleUrls: ['./../card.component.scss', './table-card.component.scss'],
})
export class TableCardComponent {
  @Input()
  table!: Table;

  databaseModelService: DatabaseModelService = inject(DatabaseModelService);
  cardsService: CardsService = inject(CardsService);

  isHovered: Observable<boolean> = this.mustBeBordered();

  mustBeBordered(): Observable<boolean> {
    return this.cardsService.getHoveredLink().pipe(
      map((link: Link | undefined) => {
        if (link == undefined) return false;
        return link.table1 === this.table.getTitle() || link.table2 === this.table.getTitle();
      })
    );
  }

  deleteTable(): void {
    this.databaseModelService.deleteTable(this.table);
  }
}
